import { render, staticRenderFns } from "./CreateNewContact.vue?vue&type=template&id=34ae1eff&scoped=true&"
import script from "./CreateNewContact.vue?vue&type=script&lang=js&"
export * from "./CreateNewContact.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewContact.vue?vue&type=style&index=0&id=34ae1eff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae1eff",
  null
  
)

export default component.exports